<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 16L12.1923 21L16 17.25L19.8077 21L25 16" stroke="black" stroke-width="2" />
    <path
        d="M20 13.97C19.5021 13.349 18.8865 12.8516 18.1952 12.5116C17.5038 12.1717 16.7529 11.9972 15.9937 12C15.2344 12.0029 14.4846 12.183 13.7955 12.5281C13.1063 12.8733 12.4939 13.3753 12 14"
        stroke="black" stroke-width="2" />
    <path
        d="M10 28H6C4.89543 28 4 27.1046 4 26V22M22 28H26C27.1046 28 28 27.1046 28 26V22M4 10V6C4 4.89543 4.89543 4 6 4H10M22 4H26C27.1046 4 28 4.89543 28 6V10"
        stroke="black" stroke-width="2" />
</svg>
